import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    event.preventDefault()
    const isDark = document.documentElement.classList.toggle('dark')

    // Toggle icon immediately
    const icon = this.element.querySelector('i')
    if (icon) {
      icon.classList.remove('bi-sun', 'bi-moon')
      icon.classList.add(isDark ? 'bi-sun' : 'bi-moon')
    }

    // Update hidden field to save current theme
    const hiddenField = this.element.querySelector('input[type="hidden"][name*="theme_preference"]')
    if (hiddenField) {
      hiddenField.value = isDark ? 'dark' : 'light'
    }

    // Update theme controller value
    document.documentElement.dataset.themePreferenceValue = isDark ? 'dark' : 'light'

    this.element.requestSubmit()
  }
}
